"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_BUTTON = void 0;
const LOAD_BUTTON = exports.LOAD_BUTTON = 'load-button';
